import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { customerAuthApi } from '../lib/api';
import AuthShell from '../components/AuthShell';

/**
 * The response is deliberately identical whether or not the address has an
 * account — otherwise this page becomes a way to test which emails are
 * registered. So the success state is shown on any accepted submission.
 */
export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await customerAuthApi.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t('auth.forgotTitle')}>

        {sent ? (
          <>
            <p className="text-sm text-gray-600 mb-6">{t('auth.forgotSent')}</p>
            <Link to="/login" className="block w-full text-center bg-brand-600 text-white py-3 rounded-lg font-medium hover:bg-brand-700">
              {t('auth.backToLogin')}
            </Link>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <p className="text-sm text-gray-600">{t('auth.forgotSubtitle')}</p>

            {error && (
              <div role="alert" className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{t('auth.email')}</label>
              <input type="email" required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <button type="submit" disabled={loading || !email}
              className="w-full bg-brand-600 text-white py-3 rounded-lg font-medium hover:bg-brand-700 disabled:opacity-50">
              {loading ? t('auth.pleaseWait') : t('auth.forgotSubmit')}
            </button>

            <Link to="/login" className="block text-center text-sm text-gray-500 hover:text-gray-700">
              {t('auth.backToLogin')}
            </Link>
          </form>
        )}
    </AuthShell>
  );
}
